import { forwardRef } from "react";
import styled from "styled-components";

import { zIndex } from "../../styles/constants";
import { cn } from "../../util/css";
import { useLoaderVisible } from "./delay";
import { Spinner } from "./Loading";

type LoadingOverlayProps = {
    transparent?: boolean;
};

// Covers its positioned parent with a spinner once loading has taken a
// moment (see ImmediateLoading). Until then it's invisible, so a fast load
// doesn't flash it, but it still blocks clicks (e.g. a second submit).
const LoadingOverlay = forwardRef<HTMLDivElement, LoadingOverlayProps>(
    ({ transparent }, ref) => {
        const visible = useLoaderVisible();
        return (
            <Overlay
                ref={ref}
                className={cn((transparent || !visible) && "transparent")}
            >
                {visible && <Spinner />}
            </Overlay>
        );
    },
);

export default LoadingOverlay;

const Overlay = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: ${zIndex.top - 11};
    transition: background-color 0.15s ease-out;

    &.transparent {
        background: transparent;
    }
`;
